import * as React from "react";
import { Collapse, Slider, Input, Switch } from "antd";
import styled from "styled-components";
import update from "immutability-helper";
import { ThemeContext } from "../../../../themeDesigner";

const Panel = Collapse.Panel;

const Label = styled.label`
  font-family: Muli;
  font-size: 13px;
  font-weight: 600;
  color: #7f90af;
  display: block;
  margin-bottom: 8px;
`;

const SettingRow = styled.div`
  margin-bottom: 16px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    flex: 1;
  }
`;

export default function HeaderProperties() {
  const { themeProps, setThemeProps } = React.useContext(ThemeContext);
  const headerStyles = themeProps.widget.modernUIStyles.header;

  const handleUpdate = (key: string, value: any) => {
    const numValue = typeof value === "number" ? value : (Array.isArray(value) ? value[0] : value);
    const updated = update(themeProps, {
      widget: {
        modernUIStyles: {
          header: {
            [key]: { $set: numValue },
          },
        },
      },
    });
    setThemeProps(updated);
  };

  return (
    <Collapse defaultActiveKey={["1"]}>
      <Panel header="Header Styles" key="1">
        <SettingRow>
          <Label>Enable Glassmorphism</Label>
          <Switch
            checked={headerStyles.enableGlassmorphism}
            onChange={(checked) => handleUpdate("enableGlassmorphism", checked)}
          />
        </SettingRow>

        {headerStyles.enableGlassmorphism && (
          <>
            <SettingRow>
              <Label>Backdrop Blur (px)</Label>
              <Wrapper>
                <Input
                  type="number"
                  value={headerStyles.backdropBlur}
                  onChange={(e) =>
                    handleUpdate("backdropBlur", parseInt(e.target.value) || 10)
                  }
                  min={0}
                  max={50}
                />
                <span>{headerStyles.backdropBlur}px</span>
              </Wrapper>
              <Slider
                value={headerStyles.backdropBlur}
                onChange={(val) => handleUpdate("backdropBlur", val)}
                min={0}
                max={50}
                step={1}
                style={{ marginTop: "8px" }}
              />
            </SettingRow>

            <SettingRow>
              <Label>Backdrop Opacity (%)</Label>
              <Wrapper>
                <Input
                  type="number"
                  value={Math.round(headerStyles.backdropOpacity * 100)}
                  onChange={(e) =>
                    handleUpdate(
                      "backdropOpacity",
                      Math.min(1, Math.max(0, parseInt(e.target.value) / 100))
                    )
                  }
                  min={0}
                  max={100}
                />
                <span>{Math.round(headerStyles.backdropOpacity * 100)}%</span>
              </Wrapper>
              <Slider
                value={Math.round(headerStyles.backdropOpacity * 100)}
                onChange={(val) => {
                  const numVal = typeof val === "number" ? val : val[0];
                  handleUpdate("backdropOpacity", numVal / 100);
                }}
                min={0}
                max={100}
                step={5}
                style={{ marginTop: "8px" }}
              />
            </SettingRow>
          </>
        )}
      </Panel>
    </Collapse>
  );
}
